import React from "react";
import { Box, CardMedia, Modal, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Hil = ({ one, onClose }) => {
  return (
    <Modal
      open={one}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 1, sm: 3 },
        background:
          "linear-gradient(180deg, rgba(20,25,60,0.55), rgba(10,10,25,0.45))",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "1200px",
          height: { xs: "85dvh", md: "700px" },
          boxSizing: "border-box",
          borderRadius: "24px",
          background:
            "linear-gradient(180deg, rgba(20,25,60,0.85), rgba(10,10,25,0.8))",
          border: "1px solid rgba(255,255,255,0.15)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          boxShadow: "0 12px 40px rgba(0,0,0,0.55)",
          p: { xs: 2, md: 3 },
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <IconButton
          onClick={onClose}
          aria-label="Гарах"
          title="Гарах"
          sx={{
            position: "absolute",
            top: { xs: 8, md: 12 },
            right: { xs: 8, md: 12 },
            zIndex: 10,
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.15)",
            border: "1px solid rgba(255,255,255,0.25)",
            "&:hover": {
              backgroundColor: "rgba(255,0,0,0.75)",
              transform: "rotate(90deg)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          sx={{
            fontWeight: 300,
            textAlign: "left",
            mb: 2,
            fontSize: "20px",
            // textShadow: "0 0 6px rgba(57, 194, 15, 0.7)",
            color: "#98f108ff",
          }}
        >
          Хилийн бүс нутагт нэвтрэх зөвшөөрөл
        </Typography>

        <CardMedia
          component="iframe"
          title="Хилийн бүс нутагт нэвтрэх зөвшөөрөл авах видео заавар"
          src="https://www.youtube.com/embed/U6z-VYEuWpA?autoplay=1&mute=0&loop=1&playlist=U6z-VYEuWpA&controls=1"
          allow="autoplay; encrypted-media"
          allowFullScreen
          sx={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            borderRadius: "18px",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
            boxSizing: "border-box",
          }}
        />
      </Box>
    </Modal>
  );
};

export default Hil;
